import { render } from "./ApplicantsTable.vue?vue&type=template&id=0fc20127"
import script from "./ApplicantsTable.vue?vue&type=script&lang=js"
export * from "./ApplicantsTable.vue?vue&type=script&lang=js"

import "./ApplicantsTable.vue?vue&type=style&index=0&id=0fc20127&lang=css"

import exportComponent from "/var/www/app.rizome-bxl.be/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__